// API endpoint URL's
export const SUBSTRATE_SEARCH_QUERY_ENDPOINT = 'search/api/v2/query';
export const SUBSTRATE_SEARCH_SUGGESTIONS_ENDPOINT = 'search/api/v1/suggestions';
export const SUBSTRATE_SEARCH_INIT_V1_ENDPOINT = 'search/api/v1/init';
export const SUBSTRATE_SEARCH_INIT_V2_ENDPOINT = 'search/api/v2/init';
export const SUBSTRATE_SEARCH_HISTORY_ENDPOINT = 'search/api/v1/searchHistory';

// SearchHistory actions
export const DELETE_HISTORY_ACTION_NAME = 'Delete';
